import script from "./discard-changes-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./discard-changes-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__